module.exports = __webpack_public_path__ + "static/media/sanduiche_1.11d2c8f6.jpg";